module.exports = __webpack_public_path__ + "img/h-page4-55.5cd52134.png";